

export const BG_ACTIVE = 'BG_ACTIVE';
export const BG_CLOSE = 'BG_CLOSE';


// WEBPACK FOOTER //
// ./src/store/mutations-types.js